const pointReducer = (state=0,action)=>{
    switch(action.type){
        case "STARTCOUNT":
            return new Date();
        case "ENDCOUNT":
            const cur = new Date();
            if(typeof(state)===typeof(cur))
            return Math.round(Math.abs((state.getTime() - cur.getTime())/1000))*10;
            else
            return state;
        default:
            return state;
    }
}

export default pointReducer;